import React from "react";
import ActionButton from "../ActionButton";
import "../../stylesHero/AddForm.css";

const DocumentUploadForm = ({
  currentSection,
  uploadedFiles,
  handleFileChange,
  handleDocumentUpload,
  uniqueId,
  missingFiles, // New prop to indicate which files are missing
}) => (
  <form className="dynamic-input-form">
    <div className="information-box">
      <p className="information-box-title">
        Please upload the required documents.
      </p>
    </div>
    <div className="form-section">
      <h3 className="form-section-heading">{currentSection?.title}</h3>
      <hr className="form-section-divider" />
      {currentSection?.fields.map((field) =>
        field.type === "file" ? (
          <div
            className={`form-group ${
              missingFiles?.includes(field.name) ? "missing-file" : ""
            }`} // Add a class if the file is missing
            key={field.name}
          >
            <label htmlFor={field.name} className="form-label">
              {field.label}:
            </label>
            <input
              type="file"
              name={field.name}
              accept={field.accept}
              onChange={(e) => handleFileChange(e, field.label)}
              className="form-input"
              required={field.required}
            />
            {missingFiles?.includes(field.name) && (
              <p className="missing-file-warning">
                This file is required. Please upload it.
              </p>
            )}
          </div>
        ) : null
      )}
    </div>
    <div className="upload-button-wrapper">
      <ActionButton label="Upload and Analyze" onClick={handleDocumentUpload} />
    </div>
  </form>
);

export default DocumentUploadForm;